import React from 'react'

function Contactus() {
    return (
        <>
            <div className="container d-flex justify-content-center align-items-center">
                <div className="contactUs-box ">
                    <h5 className='text-center'>Contact us for Issues & Doubts now..!!</h5>
                    <p className='text-center'>If You have any Issues Regarding our website and resources, you can mail us at polya2zofficial@gmail.com</p>
                    <a href="mailto: polya2zofficial@gmail.com">
                        <button className="btn btn-danger">Send Email</button>
                    </a>
                </div>
            </div>

            <div className="container d-flex justify-content-center align-items-center">
                <div className="contactUs-box ">
                    <h5 className='text-center'>The Smart Edu4u - Free Video Lectures</h5>
                    <p className='text-center'>Visit the youtube channel for free video lectures for all semesters and other important notifications.</p>
                    <a href="https://www.youtube.com/c/Thesmartedu4U">
                        <button className="btn btn-danger">Youtube</button>
                    </a>
                </div>
            </div>

            <div className="container d-flex justify-content-center align-items-center">
            <div className="contactUs-box ">
                <h5 className='text-center'>Contribute To Our Community</h5>
                <p className='text-center'>Hey If you want your notes/resources uploaded on PolyA2z then send us your Pdf's on our WhatsApp +0532 297 4609</p>
                <a href='https://api.whatsapp.com/send?phone=+91 5322974609'>
                    <button className="btn btn-success">WhatsApp</button>
                </a>
            </div>
        </div>
        </>
    )
}

export default Contactus